import React, { ReactNode } from 'react';
import { ToggleButtonGroup, ToggleButtonGroupProps } from 'react-bootstrap';

function DiscountButtonGroup<T>({
  children,
  ...rest
}: ToggleButtonGroupProps<T> & { children: ReactNode }) {
  return (
    <ToggleButtonGroup
      {...rest}
      style={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, 64px)',
        gridGap: '0.5rem',
      }}
    >
      {children}
    </ToggleButtonGroup>
  );
}

export default DiscountButtonGroup;
